import { useIsFetching, useIsMutating } from "@tanstack/react-query";

const shouldTrackQuery = (query: { meta?: Record<string, unknown> }) =>
  query.meta?.ignoreGlobalLoading !== true;

const shouldTrackMutation = (mutation: {
  options?: { meta?: Record<string, unknown> };
}) => mutation.options?.meta?.ignoreGlobalLoading !== true;

/**
 * Hook que usa las capacidades nativas de React Query para detectar loading global
 * Mucho mÃ¡s confiable que manejar estados booleanos manualmente
 */
export const useQueryLoading = () => {
  const isFetching = useIsFetching({
    predicate: (query) => shouldTrackQuery(query),
  });

  const isMutating = useIsMutating({
    predicate: (mutation) => shouldTrackMutation(mutation),
  });

  const isLoading = isFetching > 0 || isMutating > 0;

  return {
    isLoading,
    fetchingCount: isFetching,
    mutatingCount: isMutating,
  };
};

/**
 * Hook para detectar loading de queries especÃ­ficas por filtro
 */
export const useQueryLoadingByFilter = (queryKeyFilter?: string[]) => {
  const isFetching = useIsFetching({
    queryKey: queryKeyFilter,
    predicate: (query) => shouldTrackQuery(query),
  });

  return isFetching > 0;
};
